import React, { Component } from "react";
import autobind from "autobind-decorator";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import http from "../../../services/HttpService";
import Route from "../../../Routes";
import { Translation } from "react-i18next";

import MetaTags from 'react-meta-tags';
import Helmet from 'react-helmet';
import Logo_b from "../../../../assets/img/site/Logo.png";

import {
    Container,
    Row,
    Col,
    Button,
    Form,
    FormGroup,
    Label,
    FormText,
    InputGroup,
    InputGroupAddon,
    Input,
    UncontrolledTooltip,
    Carousel,
    CarouselItem,
    CarouselControl,
    CarouselIndicators,
    CarouselCaption,
    TabContent,
    TabPane,
    Nav,
    NavItem,
    NavLink,
    Card,
    CardTitle,
    CardText,
    Table,
    Progress

} from 'reactstrap';

import LayoutMaster from "../../../views/layout/Master";
import {layout} from "../../../../ts-helpers/decorators";

//import Section_01   from "../../../../assets/img/site/game_sections_image/section-01.png";
// import Loading from "../../includes/Loading";
import social_1   from "../../../../assets/img/site/Social/Asset-16.svg";
import social_3   from "../../../../assets/img/site/Social/Asset-18.svg";
import social_4   from "../../../../assets/img/site/Social/Asset-19.svg";

@layout(LayoutMaster)
class ContactPage extends Component<any> {
    state = {
        phone: '',
        email: '',
        address: '',
        skype: '',
        fax: '',
        facebook:'',
        linkedin:'',
        twitter:''
    };

    constructor(props: Map<any, any>) {
        super(props);
    }

    componentDidMount() {
        this.getData();
        this.props.onRef(this);
    }

    @autobind
    getData(){
        http.get(`/contacts/all`)
            .then(response => response.json())
            .then((data) => {
                this.setState({
                    loading: false,
                    phone: data.phone,
                    email: data.email,
                    address: data.address,
                    skype: data.skype,
                    fax: data.fax,
                    facebook: data.facebook,
                    linkedin: data.linkedin,
                    twitter: data.twitter,
                });
            })
    }

    @autobind
    langTranslation(e){
        return <Translation>{t => t(`${e}`)}</Translation>
    }

    render() {

        const {phone, email, address, fax, skype, facebook, twitter, linkedin} = this.state

        return (
            <Container>
                <Row>
                    <Helmet>
                        <title>Contact / Skillers.co</title>
                        <meta name="keywords" content="" />
                        <meta name="description" content="" />
                    </Helmet>
                    <Col className="col-sm-8 col-sm-offset-2 contact_block ">
                        <Col className="col-sm-12 contact_title">
                            <div>Contact With Us</div>
                        </Col>
                        <Col className="col-sm-8 col-sm-offset-2 contact-table-block">
                            {
                                phone &&
                                    <Row className="contac_items">
                                        <Col className="col-sm-6 text-left"><i className="fa fa-phone"></i> Phone</Col>
                                        <Col className="col-sm-6 text-right"><span>{phone}</span></Col>
                                    </Row>
                            }

                            {
                                email &&
                                    <Row className="contac_items">
                                        <Col className="col-sm-6 text-left"><i className="fa fa-envelope"></i> Email</Col>
                                        <Col className="col-sm-6 text-right"><span>{email}</span></Col>
                                    </Row>
                            }

                            {
                                address &&
                                    <Row className="contac_items">
                                        <Col className="col-sm-6 text-left"><i className="fa fa-address-book"></i> Address</Col>
                                        <Col className="col-sm-6 text-right"><span>{address}</span></Col>
                                    </Row>
                            }

                            {
                                skype &&
                                    <Row className="contac_items">
                                        <Col className="col-sm-6 text-left"><i className="fa fa-skype"></i> Skype</Col>
                                        <Col className="col-sm-6 text-right"><span>{skype}</span></Col>
                                    </Row>
                            }

                            {
                                fax &&
                                    <Row className="contac_items">
                                        <Col className="col-sm-6 text-left"><i className="fa fa-fax"></i> Fax</Col>
                                        <Col className="col-sm-6 text-right"><span>{fax}</span></Col>
                                    </Row>
                            }
                        </Col>
                        <Col className="col-sm-4 col-sm-offset-4 contact-table-block">
                            <Col className="col-xs-4">
                                <a href={facebook} target="_blank">
                                    <img className="contact_soc_icons_img" src={social_4} alt=""/>
                                </a>
                            </Col>
                            <Col className="col-xs-4">
                                <a href={linkedin} target="_blank">
                                    <img className="contact_soc_icons_img" src={social_1} alt=""/>
                                </a>
                            </Col>
                            <Col className="col-xs-4">
                                <a href={twitter} target="_blank">
                                    <img className="contact_soc_icons_img" src={social_3} alt=""/>
                                </a>
                            </Col>
                        </Col>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default ContactPage;
